import { jwtDecode } from "jwt-decode"; // Import jwt-decode without destructuring
import useAuth from "../hooks/useAuth";

function GetStaffId() {
  const { auth } = useAuth();
  const token = auth?.token;
  let staffId = null;

  if (token) {
    try {
      // Decode the token to extract user information
      const decodedToken = jwtDecode(token);
      // Extract user ID from decoded token
      staffId = decodedToken.staffId; // Modify this according to the structure of your token
      // console.log(staffId);
      return staffId;
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  }
}
export { GetStaffId };

export function formatDuration(duration) {
  if (!duration) return "N/A";

  const [number, unit] = duration.split("_");
  const capitalizedNumber = number.charAt(0).toUpperCase() + number.slice(1);
  const formattedUnit = unit.charAt(0).toUpperCase() + unit.slice(1);

  return `${capitalizedNumber} ${formattedUnit}`;
}